/**
 * TakeLead Klick-Cursor: setzt bei Mousedown die Klasse takelead-cursor-active auf <html>,
 * damit der geneigte Cursor (10°) überall angezeigt wird – auch ins Leere und über Buttons.
 *
 * Wird so früh wie möglich aus main.tsx aufgerufen (unabhängig von React-Mount),
 * damit die Klick-Animation zuverlässig funktioniert und kein Standard-Pointer aufblitzt.
 *
 * Siehe: docs/takelead-cursor.md
 */

const ACTIVE_CLASS = "takelead-cursor-active";

function shouldEnable(): boolean {
  if (typeof window === "undefined" || typeof document === "undefined") return false;
  return window.matchMedia("(hover: hover) and (pointer: fine)").matches;
}

function addActive(): void {
  document.documentElement.classList.add(ACTIVE_CLASS);
}

function removeActive(): void {
  document.documentElement.classList.remove(ACTIVE_CLASS);
}

/**
 * Registriert globale Listener für Mousedown/Mouseup etc.
 * Capture-Phase für mousedown, damit die Klasse gesetzt ist, bevor das Event
 * das Ziel erreicht – verhindert Aufblitzen des Standard-Pointer-Cursors auf Buttons.
 */
export function initTakeleadCursorActive(): void {
  if (!shouldEnable()) return;

  // Mousedown in Capture-Phase: Klasse sofort setzen, bevor Button/Link das Event bekommt
  document.addEventListener("mousedown", addActive, true);
  document.addEventListener("mouseup", removeActive, true);
  document.addEventListener("mouseleave", removeActive, true);
  // Fallbacks, falls Maus außerhalb losgelassen wird oder Kontextmenü/Drag
  document.addEventListener("contextmenu", removeActive, true);
  document.addEventListener("dragend", removeActive, true);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") removeActive();
  });
}
